// The design's print-adjacent ornament: a barcode rule and a mono serial,
// stamped beside the hero eyebrow and section headings like a plan-sheet
// drawing number. Decorative, so hidden from assistive tech — but the bars are
// a real Code 128 (subset C) symbol that scans as 081117, matching the serial
// beside it: Start C · 08 · 11 · 17 · check (83) · Stop, one module per unit.
//
// The serial is fixed here rather than passed in so the printed text can never
// disagree with what the bars encode. Exported for surfaces that print the
// serial without the bars (the webhooks signed-out provenance row).

export const BARCODE_SERIAL = '081117-CRI'

const CODE_128_BARS: readonly (readonly [x: number, width: number])[] = [
  // Start C (211232)
  [0, 2],
  [3, 1],
  [6, 3],
  // 08 (132212)
  [11, 1],
  [15, 2],
  [19, 1],
  // 11 (231212)
  [22, 2],
  [27, 1],
  [30, 1],
  // 17 (123221)
  [33, 1],
  [36, 3],
  [41, 2],
  // check digit 83 (114212)
  [44, 1],
  [46, 4],
  [52, 1],
  // Stop (2331112)
  [55, 2],
  [60, 3],
  [64, 1],
  [66, 2],
]

export const BarcodeStamp = ({
  tone,
}: {
  /** `strong` beside the hero eyebrow, `muted` on section header rules. */
  tone: 'strong' | 'muted'
}) => (
  <span
    aria-hidden="true"
    style={{ display: 'inline-flex', alignItems: 'center', gap: 14 }}
  >
    <svg
      width={68}
      height={13}
      viewBox="0 0 68 13"
      fill="currentColor"
      style={{
        color:
          tone === 'strong' ? 'var(--curri-text)' : 'var(--curri-text-tertiary)',
        flex: 'none',
      }}
    >
      {CODE_128_BARS.map(([x, width]) => (
        <rect key={x} x={x} y={0} width={width} height={13} />
      ))}
    </svg>
    <span
      style={{
        fontFamily: 'var(--curri-font-mono)',
        fontSize: 11,
        color: 'var(--curri-text-tertiary)',
      }}
    >
      {BARCODE_SERIAL}
    </span>
  </span>
)
